@if (content) {
  @if (shippingCards) {
    <div class="cx-shipping-address-card d-flex ng-star-inserted">
      <div class="cx-shipping-address-card-inner">
        @if (content) {
          <div class="cx-card" [class.cx-card-border]="border"
            [class.cx-card-fit-to-container]="fitToContainer">
            <!-- Card Body -->
            <div class="card-body cx-card-body" [class.cx-card-delete]="editMode">
              <!-- Edit message -->
              @if (editMode) {
                <div class="cx-card-delete-msg">
                  {{ content.deleteMsg }}
                </div>
              }
              <!-- Card Content -->
              <div class="cx-card-container">
                <!-- Card Label -->
                <div [class]="length ? 'cx-card-label-container flex-column': 'cx-card-label-container'">
                  <!-- Card Header -->
                  @if (shippingCards) {
                    <div class="card-header">
                      @if (content.textBold) {
                        <div class="cx-card-label-bold">
                          {{ content.textBold }}
                        </div>
                      }
                      @if (!editMode) {
                        <button class="btn btn-sm {{content.header  ? 'is-default' : ''}}"
                          (click)="setDefault()" (keydown.enter)="setDefault()">
                          @if ( showDefaultText) {
                            <span class="text">{{'addressCard.default' | cxTranslate}}</span>
                          }
                          <span class="card-btn-default">
                            @if (content.header ) {
                              <app-custom-icons [type]="iconType.CLOSE"></app-custom-icons>
                            }
                          </span>
                        </button>
                      }
                    </div>
                  }
                  <div class="cx-card-content">
                    @for (line of content.text; track line; let i = $index) {
                      <div>
                        @if (!truncateText) {
                          <div class="cx-card-label">
                            {{line?.replace('undefined', '')}}
                          </div>
                        } @else {
                          <cx-truncate-text-popover [charactersLimit]="charactersLimit" [content]="line">
                          </cx-truncate-text-popover>
                        }
                      </div>
                    }
                  </div>
                  @for (item of content.paragraphs; track item) {
                    <div class="cx-card-paragraph">
                      <div class="cx-card-paragraph-title">{{ item.title }}</div>
                      @for (text of item.text; track text) {
                        <div>
                          <div class="cx-card-paragraph-text">
                            {{ text }}
                          </div>
                        </div>
                      }
                    </div>
                  }
                </div>
                <!-- Image -->
                @if (content.img) {
                  <div class="cx-card-img-container">
                    <cx-icon [type]="content.img"></cx-icon>
                  </div>
                }
              </div>
              <!-- Edit Mode Actions -->
              @if (editMode) {
                <div class="row cx-card-body-delete">
                  <div class="col-md-6">
                    <button class="btn btn-block btn-primary" (click)="delete()">
                      {{ 'common.remove' | cxTranslate }}
                    </button>
                  </div>
                  <div class="col-md-6 btn-container">
                    <a class="btn-history-back" (click)="cancelEdit()">
                      {{ 'common.cancel' | cxTranslate }}
                    </a>
                  </div>
                </div>
              }
              <!-- Footer Actions -->
              @if (content.actions && !editMode) {
                <div class="cx-card-actions">
                  @for (action of content.actions; track action) {
                    <div>
                      <div>
                        @switch (action.event) {
                          @case ('default') {
                          }
                          @case ('delete') {
                            <a class="cx-card-link card-link cx-action-link font-weight-light"
                            (click)="delete()" (keydown.enter)="delete()" tabindex="0">{{ action.name }}</a>
                          }
                          @case ('send') {
                            <a class="cx-card-link card-link cx-action-link cx-send-action" (click)="send()"
                            (keydown.enter)="send()" tabindex="0">{{ action.name }}</a>
                          }
                          @case ('edit') {
                            <a class="cx-card-link card-link cx-action-link editar" (click)="edit()"
                              (keydown.enter)="edit()" tabindex="0">{{ action.name }}
                            </a>
                          }
                        }
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>
  } @else {
    <div class="cx-card" [class.cx-card-border]="border" [class.cx-card-fit-to-container]="fitToContainer">
      <!-- Card Body -->
      <div class="card-body cx-card-body" [class.cx-card-delete]="editMode">
        <!-- Edit message -->
        @if (editMode) {
          <div class="cx-card-delete-msg">
            {{ content.deleteMsg }}
          </div>
        }
        <!-- Card Content -->
        <div class="cx-card-container">
          <!-- Card Label -->
          <div [class]="length ? 'cx-card-label-container flex-column': 'cx-card-label-container'">
            <!-- Actions -->
            @if (content.actions && !editMode) {
              <div class="cx-card-actions">
                @for (action of content.actions; track action) {
                  <div>
                    <div>
                      @switch (action.event) {
                        @case ('delete') {
                          <a class="cx-card-link card-link btn-black cx-action-link" (click)="delete()"
                          (keydown.enter)="delete()" tabindex="0">{{ action.name }}</a>
                        }
                        @case ('default') {
                          <a class="cx-card-link card-link btn-black cx-action-link"
                          (click)="setDefault()" (keydown.enter)="setDefault()" tabindex="0">{{ action.name }}</a>
                        }
                        @case ('send') {
                          <a class="cx-card-link card-link cx-action-link cx-send-action"
                          (click)="send()" (keydown.enter)="send()" tabindex="0">{{ action.name }}</a>
                        }
                        @case ('edit') {
                          <a class="cx-card-link card-link btn-black cx-action-link" (click)="edit()"
                          (keydown.enter)="edit()" tabindex="0">{{ action.name }}</a>
                        }
                        @default {
                          <a href="{{ action.link }}" class="card-link btn-link cx-action-link"
                          tabindex="0">{{ action.name }}</a>
                        }
                      }
                    </div>
                  </div>
                }
              </div>
            }
            <!-- Card Header -->
            @if (shippingCards && length) {
              <div class="card-header">
                @if (content.header && !editMode) {
                  <app-custom-icons [type]="iconType.TIMES"></app-custom-icons>
                }
              </div>
            }
            @if (content.textBold) {
              <div class="cx-card-label-bold">
                {{ content.textBold }}
              </div>
            }
            <div class="cx-card-content">
              @for (line of content.text; track line; let i = $index) {
                <div>
                  @if (!truncateText) {
                    <div class="cx-card-label">
                      {{ line }}
                    </div>
                  } @else {
                    <cx-truncate-text-popover [charactersLimit]="charactersLimit" [content]="line">
                    </cx-truncate-text-popover>
                  }
                </div>
              }
            </div>
            @for (item of content.paragraphs; track item) {
              <div class="cx-card-paragraph">
                <div class="cx-card-paragraph-title">{{ item.title }}</div>
                @for (text of item.text; track text) {
                  <div>
                    <div class="cx-card-paragraph-text">
                      {{ text }}
                    </div>
                  </div>
                }
              </div>
            }
          </div>
          <!-- Image -->
          @if (content.img) {
            <div class="cx-card-img-container">
              <cx-icon [type]="content.img"></cx-icon>
            </div>
          }
        </div>
        <!-- Edit Mode Actions -->
        @if (editMode) {
          <div class="row cx-card-body-delete">
            <div class="col-md-6">
              <button class="btn btn-block btn-primary" (click)="delete()">
                {{ 'common.remove' | cxTranslate }}
              </button>
            </div>
            <div class="col-md-6 btn-container">
              <a class="btn-history-back" (click)="cancelEdit()">
                {{ 'common.cancel' | cxTranslate }}
              </a>
            </div>
          </div>
        }
      </div>
    </div>
  }
}
